import { axios, transformAxiosError } from "../utils/axios.create";
import {
  ExternalProvider,
  ExternalProviderPayload,
} from "../domain/externalProviders.interface";

export type ExternalProvidersFindAllPayload = {
  sortField: string;
  sortOrder: number;
  pageNumber: number;
  pageSize: number;
  search: string;
  status: string;
  categoryId: string;
};

const findAll = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
  status,
  categoryId,
}: ExternalProvidersFindAllPayload): Promise<{
  list: ExternalProvider[];
  totalCount: number;
}> => {
  const queryParams = new URLSearchParams({
    search,
    status,
    categoryId,
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/external-providers/search?${queryParams.toString()}`)
    .then((res) => ({
      list: res.data.body.list as ExternalProvider[],
      totalCount: res.data.body.totalCount as number,
    }))
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const createOne = async (
  payload: ExternalProviderPayload
): Promise<ExternalProvider> => {
  return axios
    .post("/external-providers", payload)
    .then((res) => res.data.body as ExternalProvider)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const updateOne = async ({
  id,
  payload,
}: {
  id: string;
  payload: ExternalProviderPayload;
}): Promise<ExternalProvider> => {
  return axios
    .put(`/external-providers/${id}`, payload)
    .then((res) => res.data.body as ExternalProvider)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const archiveOne = async (id: string): Promise<void> => {
  return axios
    .delete(`/external-providers/${id}`)
    .then(() => undefined)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const ExternalProvidersService = {
  findAll,
  createOne,
  updateOne,
  archiveOne,
};
